export const HELP_ARTICLES_CALL = 'HELP_ARTICLES_CALL';
export const HELP_ARTICLE_GET_CALL = 'HELP_ARTICLE_GET_CALL';
export const HELP_ARTICLE_CREATE_CALL = 'HELP_ARTICLE_CREATE_CALL';
export const HELP_ARTICLE_UPDATE_CALL = 'HELP_ARTICLE_UPDATE_CALL';
export const HELP_ARTICLE_DELETE_CALL = 'HELP_ARTICLE_DELETE_CALL';
export const HELP_CATEGORIES_CALL = 'HELP_CATEGORIES_CALL';
export const HELP_CATEGORY_CREATE_CALL = 'HELP_CATEGORY_CREATE_CALL';
export const HELP_CATEGORY_UPDATE_CALL = 'HELP_CATEGORY_UPDATE_CALL';
export const HELP_CATEGORY_DELETE_CALL = 'HELP_CATEGORY_DELETE_CALL';
export const HELP_ARTICLES_SEARCH_CALL = 'HELP_ARTICLES_SEARCH_CALL';
export const HELP_ARTICLE_VIEW_CALL = 'HELP_ARTICLE_VIEW_CALL';
export const HELP_ARTICLE_BY_SLUG_CALL = 'HELP_ARTICLE_BY_SLUG_CALL';
export const HELP_TENANT_CATEGORIES_CALL = 'HELP_TENANT_CATEGORIES_CALL';
export const HELP_TENANT_ARTICLES_CALL = 'HELP_TENANT_ARTICLES_CALL';
export const HELP_ARTICLE_UPLOAD_IMAGE_CALL = 'HELP_ARTICLE_UPLOAD_IMAGE_CALL';

// Admin (SuperUser) actions
export function callHelpArticles(params) {
    return { type: HELP_ARTICLES_CALL, payload: params };
}

export function callGetHelpArticle(articleId) {
    return { type: HELP_ARTICLE_GET_CALL, payload: { articleId } };
}

export function callCreateHelpArticle(data) {
    return { type: HELP_ARTICLE_CREATE_CALL, payload: data };
}

export function callUpdateHelpArticle(articleId, data) {
    return { type: HELP_ARTICLE_UPDATE_CALL, payload: { articleId, data } };
}

export function callDeleteHelpArticle(articleId) {
    return { type: HELP_ARTICLE_DELETE_CALL, payload: { articleId } };
}

// Categories
export function callHelpCategories() {
    return { type: HELP_CATEGORIES_CALL };
}

export function callCreateHelpCategory(data) {
    return { type: HELP_CATEGORY_CREATE_CALL, payload: data };
}

export function callUpdateHelpCategory(categoryId, data) {
    return { type: HELP_CATEGORY_UPDATE_CALL, payload: { categoryId, data } };
}

export function callDeleteHelpCategory(categoryId) {
    return { type: HELP_CATEGORY_DELETE_CALL, payload: { categoryId } };
}

// End-user (TenantUser) actions
export function callSearchHelpArticles(query) {
    return { type: HELP_ARTICLES_SEARCH_CALL, payload: { query } };
}

export function callRecordArticleView(articleId) {
    return { type: HELP_ARTICLE_VIEW_CALL, payload: { articleId } };
}

export function callGetHelpArticleBySlug(slug) {
    return { type: HELP_ARTICLE_BY_SLUG_CALL, payload: { slug } };
}

export function callTenantHelpCategories() {
    return { type: HELP_TENANT_CATEGORIES_CALL };
}

export function callTenantHelpArticles(params) {
    return { type: HELP_TENANT_ARTICLES_CALL, payload: params };
}

// Image upload — file (FormData) or URL download
export function callUploadHelpArticleImage(fileOrUrl) {
    return { type: HELP_ARTICLE_UPLOAD_IMAGE_CALL, payload: fileOrUrl };
}
